//#region src/utils/object-utils.ts
var getType = (obj) => {
	return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
};
var mergeObj = (clone, obj) => {
	for (const [key, value] of Object.entries(obj)) {
		const type = getType(value);
		if (clone[key] !== void 0 && getType(clone[key]) === type && ["array", "object"].includes(type)) clone[key] = mergeObjects(clone[key], value);
		else clone[key] = structuredClone(value);
	}
};
var mergeObjects = (...objs) => {
	let clone = structuredClone(objs.shift());
	for (const obj of objs) {
		const type = getType(obj);
		if (getType(clone) !== type) {
			clone = structuredClone(obj);
			continue;
		}
		if (type === "array") clone = [...clone, ...structuredClone(obj)];
		else if (type === "object") mergeObj(clone, obj);
		else clone = obj;
	}
	return clone;
};
//#endregion
export { mergeObjects };

//# sourceMappingURL=object-utils.js.map